import Center from '../../commons/layout/Center';
import React from 'react';

const GenericNotFound = () => <Center>Sorry, page not found!</Center>;
export default GenericNotFound;
